module.exports = __webpack_public_path__ + "img/lr.e00a26ac.svg";